import { createContext, useContext, useEffect, useState } from "react";
import { checkAuthAdminApi } from "../api/authApi";

const AuthContext = createContext(null);

// ================== CUSTOM HOOK ==================

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }
  return context;
};

// ================== PROVIDER ==================


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const data = await checkAuthAdminApi();
        setUser(data?.user || { role: "admin" }); 
      } catch (error) {
        setUser(null);
      } finally {
        setAuthChecked(true); 
      }
    };

    checkAuth();
  }, []);

  // ================== CONTEXT VALUE ==================


  const value = {
    user,                
    isAuthenticated: !!user,
    authChecked,         
    setUser,             
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};